
  <div class="line d-none d-md-block" style="position: absolute;height: 100vh;">
    <img src="assets/img/line.png" height="100%" >
  </div>
  <div class="row align-items-center bg-img bg-content" style=" ">
    <div class="col">
      <div class="flex-center" style="height: 100vh;">
        <div class="card card-shadow" >
          <div class="card-body">
            <img class="logo" style="margin-top: 6px;" src="assets/img/Logo-Coomeva.png">
            <p class="title" style="margin-bottom: .5rem;text-align: center;margin-top: .5rem;">Bienvenido a tu matricula cuenta</p>
          </div>
        </div>
      </div>
    </div>
  </div>


// WEBPACK FOOTER //
// ./src/app/pages/loginSilencioso/loginSilencioso.component.html